import { useState, useEffect } from "react";
import { CaracteristicasEmprendimento } from "../../../interfaces/CaracteristicasEmprendimento";
import { buscarCaracteristicasEmpreendimentoService } from "../../../services/buscarCaracteristicasEmpreendimentoService";

export const useBuscarCaracteristicasEmpreendimento = (
  isModalOpen: boolean,
  empreendId: number
) => {
  const [caracteristicasEmpreend, setCaracteristicasEmpreend] = useState<
    CaracteristicasEmprendimento[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const buscar = async () => {
      setIsLoading(true);
      const data = await buscarCaracteristicasEmpreendimentoService(empreendId);
      setCaracteristicasEmpreend(data);
      setIsLoading(false);
    };

    if (isModalOpen && empreendId) {
      buscar();
    }
  }, [isModalOpen, empreendId]);

  return { caracteristicasEmpreend, isLoading };
};
